import React from 'react';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';

export const reportIcon = (
  value: boolean,
  selected: string,
  disabled: string
) => (
  <InsertDriveFileOutlinedIcon
    style={{ width: '21', marginLeft: '-3px', marginRight: '-3px', color: value ? selected : disabled }}
    id="iconMenu-icon-report"
  />
);
